// extracted by mini-css-extract-plugin
export default {"container":"beam-switch_container__7Gs5e","switch-container":"beam-switch_switch-container__lBS6P","switch":"beam-switch_switch__AfA8b","label":"beam-switch_label__MLX3-"};